/**
 * F2 Active Profile selector — tab-safe runtime, last-used preference only.
 * Not authorisation. Backend evaluateProfileAccessV2 is the authority.
 */

export const SELECTED_PROFILE_RUNTIME_KEY = "selectedProfileId.runtime";
export const SELECTED_PROFILE_PREFERENCE_KEY = "selectedProfileId";

function hasSessionStorage() {
  try {
    return typeof sessionStorage !== "undefined";
  } catch {
    return false;
  }
}

function hasLocalStorage() {
  try {
    return typeof localStorage !== "undefined";
  } catch {
    return false;
  }
}

export function getRuntimeSelectedProfileId() {
  if (!hasSessionStorage()) return null;
  return sessionStorage.getItem(SELECTED_PROFILE_RUNTIME_KEY) || null;
}

export function getLastUsedProfilePreference() {
  if (!hasLocalStorage()) return null;
  return localStorage.getItem(SELECTED_PROFILE_PREFERENCE_KEY) || null;
}

export function setSelectedProfileId(id) {
  const next = id || null;
  if (hasSessionStorage()) {
    if (next) sessionStorage.setItem(SELECTED_PROFILE_RUNTIME_KEY, next);
    else sessionStorage.removeItem(SELECTED_PROFILE_RUNTIME_KEY);
  }
  if (hasLocalStorage() && next) {
    localStorage.setItem(SELECTED_PROFILE_PREFERENCE_KEY, next);
  }
  return next;
}

/**
 * Runtime first (this tab). Last-used preference only if this tab has none
 * and the preference is still enterable. Stale preference never wins.
 */
export function resolveInitialSelectedProfileId(enterableIds = []) {
  const allowed = new Set((enterableIds || []).filter(Boolean));
  const runtime = getRuntimeSelectedProfileId();
  if (runtime && (allowed.size === 0 || allowed.has(runtime))) {
    return runtime;
  }
  const preference = getLastUsedProfilePreference();
  if (preference && (allowed.size === 0 || allowed.has(preference))) {
    if (hasSessionStorage()) {
      sessionStorage.setItem(SELECTED_PROFILE_RUNTIME_KEY, preference);
    }
    return preference;
  }
  return null;
}

export function clearStaleSelectedProfilePreference() {
  if (hasLocalStorage()) {
    localStorage.removeItem(SELECTED_PROFILE_PREFERENCE_KEY);
  }
}
